export enum WorkOrderLogTypeEnum {
    WoPickup = 'WoPickup',
    WoDiagnose = 'WoDiagnose',
    WoRepair = 'WoRepair',
    WoClaim = 'WoClaim',
    WoNowClaim = 'WoNowClaim',
    WoInstruction = 'WoInstruction',
    WoOnHold = 'WoOnHold',
    WoUnfix = 'WoUnfix',
    WoVoidQc = 'WoVoidQc',
    WoVoidNowClaim = 'WoVoidNowClaim',
    WoUndemarcation = 'WoUndemarcation',
    WoQualityControl = 'WoQualityControl',
    WoNonRepair = 'WoNonRepair',
    WoNonRepairRevocation = 'WoNonRepairRevocation',
    WoDeclineDemarcation = 'WoDeclineDemarcation'
}
